import { Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { NewsStore } from './pages/ccf/news/store/news.store';
import { NewsletterComponent } from './pages/newsletter/newsletter.component';
import { NewsletterStore } from './pages/newsletter/store/newsletter.store';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  {
    path: 'newsletter',
    title: 'BMW Behörden werbliche Kommunikation',
    component: NewsletterComponent,
    providers: [NewsletterStore],
    loadChildren: () => import('./pages/newsletter/newsletter.routes').then((m) => m.NEWSLETTER_ROUTES),
  },
  {
    path: '',
    canMatch: [() => environment.name !== 'production'],
    loadComponent: () => import('./pages/ccf/ccf.component').then((m) => m.CcfComponent),
    providers: [NewsStore],
    loadChildren: () => import('./pages/ccf/ccf.routes').then((m) => m.CCF_ROUTES),
  },
  { path: '**', redirectTo: 'newsletter' },
];
